module.exports = __webpack_public_path__ + "img/02.42ecd1bc.png";